module.exports = function anonymous(it
) {
var out='<span class="import-in-progress-msg label label-warning">'+(it.msg)+'</span>';return out;
}